export enum LayoutDirection {
  COLUMN = 'column',
  ROW = 'row',
}

export enum LayoutAlignItems {
  START = 'start',
  CENTER = 'center',
  END = 'end',
  STRETCH = 'stretch',
  BASELINE = 'baseline',
}

export enum LayoutJustifyContent {
  START = 'start',
  CENTER = 'center',
  END = 'end',
  SPACE_BETWEEN = 'space-between',
}

export enum LayoutMediaQuery {
  HIDE_ON_SMALL_SCREENS = 'hide_on_small_screens',
  HIDE_ON_LARGE_SCREENS = 'hide_on_large_screens',
}

export enum LayoutPadding {
  SMALL = 'small',
  LARGE = 'large',
}
